import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FileSignature } from '../types/file-signature';
import { Observable } from 'rxjs';
import { FileStore } from '../stores/file.store';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private http = inject(HttpClient);
  private fileStore = inject(FileStore);

  updateFileStoreSignature(signature: string): void {
    this.fileStore.setSignature(signature);
  }

  updateFileStoreContainerName(containerName: string): void {
    this.fileStore.setContainerName(containerName);
  }

  updateFileStoreFileGuid(fileGuid: string): void {
    this.fileStore.setTargetFileGuid(fileGuid);
  }

  updateFileStoreFileSignatureInfo(fileSignature: FileSignature): void {
    this.fileStore.setFileSignatureInfo(fileSignature);
  }

  updateFileStoreAccessCode(accessCode: string) {
    this.fileStore.setAccessCode(accessCode);
  }

  /**
   * ファイル情報を署名で取得するメソッド（URLエンコーディング対応）
   * @param containerName コンテナ名
   * @param signature ファイルの署名
   * @return Observable<FileSignature>
   */
  public getFileInfoBySignature(containerName: string, signature: string): Observable<FileSignature> {
    const params = new HttpParams()
      .set('containerName', containerName)
      .set('signature', signature);

    return this.http.get<FileSignature>(`${environment.apiUrl}api/file/verify`, { params });
  }

  /**
   * アクセスコードを検証するメソッド（URLエンコーディング対応）
   * @param containerName コンテナ名
   * @param signature ファイルの署名
   * @param accessCode アクセスコード（記号を含む場合も対応）
   * @return Observable<FileSignature>
   */
  public verifyAccessCode(containerName: string, signature: string, accessCode: string): Observable<FileSignature> {
    const params = new HttpParams()
      .set('containerName', containerName)
      .set('signature', signature)
      .set('accessCode', accessCode); // HttpParamsが自動的にエンコードする

    return this.http.get<FileSignature>(`${environment.apiUrl}api/file/verifyAccessCode`, { params });
  }

  /**
   * ファイルのダウンロード用のSAS URLを生成するメソッド（URLエンコーディング対応）
   * @param containerName コンテナ名
   * @param signature ファイルの署名
   * @param accessCode アクセスコード（記号を含む場合も対応）
   * @return Observable<FileSignature>
   */
  public getFileDownloadSASUrl(containerName: string, signature: string, accessCode: string, targetFileGuid: string | null): Observable<FileSignature> {
    let params = new HttpParams()
      .set('containerName', containerName)
      .set('signature', signature)
      .set('accessCode', accessCode); // HttpParamsが自動的にエンコードする
    if (targetFileGuid) {
      params = params.set('fileGuid', targetFileGuid);
    }

    return this.http.get<FileSignature>(`${environment.apiUrl}api/file/download`, { params });
  }
}
